import { useRouter } from 'next/router';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { PostContext } from '../../../../../context/PostContext';
import ExpiredRecruitDate from './ExpiredRecruitDate';
import HashTags from './Hashtag';

export const PStyled = styled('p')({
  a: {
    color: '#009CE0',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  p: {
    lineHeight: '140%',
    marginBottom: '1.4em',
    ':last-child': {
      marginBottom: 0,
    },
  },
  'li::marker': {
    fontSize: '1em',
  },
});

const PostBodyUI = () => {
  const { images, content, isLocked } = useContext(PostContext);
  const hasThumbnail = images.length > 0;
  const router = useRouter();
  const { pid } = router.query;
  const [showSeeMore, setShowSeeMore] = useState<boolean>(false);

  const contentRef = useRef<HTMLParagraphElement>(null);

  const [maxHeight, setMaxHeight] = useState<number | string>(0);

  // Calculate max height of post content
  // Each (line of text) or (gap between paragraphs) is:
  // line height = 1.4 rem = 1.4 * font size
  // Set maxHeight to be 3*(line height) or 5*(line height) depends on
  // whether there's a thumbnail or not
  useEffect(() => {
    if (!contentRef.current) return;
    const linesAllowed = isLocked ? 1 : hasThumbnail ? 3 : 5;
    setMaxHeight(
      parseFloat(getComputedStyle(contentRef.current).fontSize) *
        1.4 *
        linesAllowed
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef.current, hasThumbnail, isLocked]);

  // check to see if the content is line-clamped
  // i.e if the content is line-clamped, there is more text to be shown
  // use this to render "Xem thêm..." button
  const isClamped = useMemo(() => {
    return typeof maxHeight === 'number'
      ? (contentRef.current?.scrollHeight as number) > maxHeight
      : false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef.current, maxHeight]);

  useEffect(() => {
    if (pid && !isLocked) {
      setShowSeeMore(true);
    }
  }, [isLocked, pid]);

  return (
    <div>
      <ExpiredRecruitDate />
      <HashTags />
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        ref={contentRef}
        style={{
          maxHeight: !showSeeMore ? maxHeight : 'none',
          overflowY: 'hidden',
        }}
        className="[&>li]::marker:font-[1em] whitespace-normal break-words text-base font-medium tracking-[-0.0125em] marker:text-[1em] [&>a]:text-[#009CE0] [&>a]:hover:underline [&>p:last-child]:mb-0 [&>p]:mb-[1.4em] [&>p]:leading-[140%]"
      />
      {!showSeeMore && isClamped ? (
        <>
          <span>... </span>
          {!isLocked && (
            <span
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowSeeMore((prev) => !prev);
                setMaxHeight('none');
              }}
              className="cursor-pointer text-sm font-semibold leading-4 tracking-[-0.1px] text-Primary/Main hover:underline"
            >
              Xem thêm
            </span>
          )}
        </>
      ) : null}
    </div>
  );
};
export default PostBodyUI;
